// Module C — Medication Adherence Manager (Adherence Board)
// Cola de polifarmacia/adherencia con PDC por clase terapéutica y refill gaps.

import MedicationAdherencePage from "./pages/MedicationAdherencePage";

// Export routes for AppRouter
export const medicationAdherenceRoutes = [
  {
    path: "/medication-adherence",
    element: <MedicationAdherencePage />,
  },
];

// Export components for external use
export { default as MedicationAdherencePage } from "./pages/MedicationAdherencePage";
